import './Features.css';
import { useInView } from 'react-intersection-observer'; // <-- 1. IMPORT THE HOOK
// Features Section
export const Features = () => {

  const features = [
    
  { icon: 'assets/money_save.png', title: 'Post Ads for Free', desc: 'List as many ads as you want without any upfront cost' },

  { icon: 'assets/qobo_cropped.png', title: 'AI-Powered Simplicity', desc: 'Create listings effortlessly with smart automation' },

  { icon: 'assets/safe_trust.png', title: 'Safe & Trusted', desc: 'Secure chats and verified users for peace of mind' },

  { icon: 'assets/local.png', title: 'Local First', desc: 'Connect with buyers and sellers near you' },

  ];

  const { ref, inView } = useInView({
    threshold: 0.35,
  });

  return (
    <section ref={ref} className="features">
      <div className="container">
        <h2 className={`feature-sec-title fade-in-section ${inView ? 'is-visible' : ''}`}>
          Why Choose Qinto?
        </h2>

        <p
          className={`feature-sec-subtitle fade-in-section ${inView ? 'is-visible' : ''
            }`}
        >
          An intelligent marketplace that does the heavy lifting for you
        </p>

        <div className="features-grid">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className={`feature-card animate-on-scroll fade-in-section ${inView ? 'is-visible' : ''
                }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="feature-icon">
                
                <img style={{width: "150px"}} src = {feature.icon}/>
                
                </div>
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>


            </div>
          ))}
        </div>
      </div>
    </section>

  );
};
